<template>
  <div class="scence" style="font-size:16px;width:100%;background:#eff1f5">
    <div class="content">
      <!-- <div class="countryList">
          <div class="country">
              <span>乡镇：</span>
          </div>
          <div class="country">
              <span @click="setAllCheck()" :class="{ countryon: all }">全部</span>
          </div>
          <div class="country" v-for="(item,index) in towns" :key="index">
              <span @click="setListCheck(index, item.adcd)" :class="{ countryon: item.check }">{{item.adnm}}</span>
          </div>
      </div> -->
      <TownName ref="townlist" v-on:townadcd="townAdcd"></TownName>
      <div class="skt" ref="skt">
        <div class="select">
          <span v-if="allowsPerm.delete" id="del" @click="delDialog(multipleSelection)"><span class="del-icon"></span>删除</span>
          <span v-if="allowsPerm.update" id="edit" @click="editDialog"><span class="edit-icon"></span>编辑</span>
          <span v-if="allowsPerm.insert" id="add" @click="addDialog"><span class="add-icon"></span>新增</span>
          <!-- <span id="add"><span class="add-icon"></span>新增</span> -->
        </div>
        <div class="tablebox">
          <div class="fzxxtable">
            <el-table ref="multipleTable" @row-click="clickRow" v-loading="loading" :data="tdata" :max-height="height" border @selection-change="handleSelectionChange" style="width: 100%; text-align: center;">
              <el-table-column type="selection" width="40" align="center">
              </el-table-column>
              <el-table-column type="index" width="60" label="序号" align="center" header-align="center">
              </el-table-column>
              <el-table-column prop="adcdnm" align="center" label="乡镇" min-width="150">
              </el-table-column>
              <el-table-column prop="population" align="right" header-align="center" label="总人口/（人）" min-width="90" :render-header="renderheader">
              </el-table-column>
              <el-table-column prop="landArea" align="right" header-align="center" label="土地面积/（km2）" min-width="110" :render-header="renderheader">
              </el-table-column>
              <el-table-column prop="cultiArea" align="right" header-align="center" label="耕地面积/（亩）" min-width="100" :render-header="renderheader">
              </el-table-column>
              <el-table-column label="经济财产情况（户）" align="center">
                  <el-table-column prop="propertyTotal" align="right" label="总计" min-width="70">
                  </el-table-column>
                  <el-table-column prop="property1" align="right" label="Ⅰ类" min-width="70">
                  </el-table-column>
                  <el-table-column  prop="property2" align="right" label="Ⅱ类" min-width="70">
                  </el-table-column>
                  <el-table-column  prop="property3" align="right" label="Ⅲ类" min-width="70">
                  </el-table-column>
                  <el-table-column prop="property4" align="right" label="Ⅳ类" min-width="70">
                  </el-table-column>
              </el-table-column>
              <el-table-column label="住房情况（户)" align="center">
                <el-table-column prop="houseconditionTotal" align="right" label="总计" min-width="70">
                </el-table-column>
                <el-table-column prop="housecondition1" align="right" label="Ⅰ类" min-width="70">
                </el-table-column>
                <el-table-column  prop="housecondition2" align="right" label="Ⅱ类" min-width="70">
                </el-table-column>
                <el-table-column  prop="housecondition3" align="right" label="Ⅲ类" min-width="70">
                </el-table-column>
                <el-table-column prop="housecondition4" align="right" label="Ⅳ类" min-width="70">
                </el-table-column>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <!-- 新增/编辑 -->
    <el-dialog
      class="abow_dialog"
      :title="status + '防治区信息'"
      :close-on-click-modal="false"
      :visible.sync="addbtn"
      >
      <el-form ref="groupForm" :rules="rules" :model="form" label-width="170px" label-height="40px">
        <el-form-item label="乡镇" prop="adcdid">
          <el-cascader
            v-model="form.adcdid"
            separator="-"
            :options="mutiRanksAdcd"
            :props="{ expandTrigger: 'hover' }"
            @change="handleChange">
          </el-cascader>
        </el-form-item>
        <el-form-item label="总人口:" prop="population">
          <el-input v-model="form.population"></el-input>
          <label>(人)</label>
        </el-form-item>
        <el-form-item label="土地面积" prop="landArea">
          <el-input v-model="form.landArea"></el-input>
          <label>(km2)</label>
        </el-form-item>
        <el-form-item label="耕地面积" prop="cultiArea">
          <el-input v-model="form.cultiArea"></el-input>
          <label>(亩)</label>
        </el-form-item>
        <el-form-item label="经济财产情况Ⅰ类" prop="property1">
          <el-input v-model="form.property1"></el-input>
          <label>(户)</label>
        </el-form-item>
        <el-form-item label="经济财产情况Ⅱ类" prop="property2">
          <el-input v-model="form.property2"></el-input>
          <label>(户)</label>
        </el-form-item>
        <el-form-item label="经济财产情况Ⅲ类" prop="property3">
          <el-input v-model="form.property3"></el-input>
          <label>(户)</label>
        </el-form-item>
        <el-form-item label="经济财产情况Ⅳ类" prop="property4">
          <el-input v-model="form.property4"></el-input>
          <label>(户)</label>
        </el-form-item>
        <el-form-item label="住房情况Ⅰ类" prop="housecondition1">
          <el-input v-model="form.housecondition1"></el-input>
          <label>(户)</label>
        </el-form-item>
        <el-form-item label="住房情况Ⅱ类" prop="housecondition2">
            <el-input v-model="form.housecondition2"></el-input>
            <label>(户)</label>
        </el-form-item>
        <el-form-item label="住房情况Ⅲ类" prop="housecondition3">
          <el-input v-model="form.housecondition3"></el-input>
          <label>(户)</label>
        </el-form-item>
        <el-form-item label="住房情况Ⅳ类" prop="housecondition4">
          <el-input v-model="form.housecondition4"></el-input>
          <label>(户)</label>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addbtn = false">取 消</el-button>
        <el-button type="primary" @click="onGroupSave">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import scenceTypes from '@/store/types/scence'
import monitorTypes from '@/store/types/monitor'
import TownName from '@/components/Townname/index.vue'
export default {
  name: 'Scence',
  components: {
    TownName
  },
  data () {
    return {
      all: true,
      towns: [],
      checkarr: [],
      loading: true,
      height: 10,
      aDCD: '330324',
      form: { name: '' },
      addbtn: false,
      delbtn: false,
      editbtn: false,
      adcdval: [],
      adcds: [],
      mutiRanksAdcd: [],
      pageIndex: '1',
      pageSize: '100',
      tdata: [],
      delId: [],
      isTown: true,
      searchName: '',
      multipleSelection: [],
      status: '新增',
      valueId: '',
      adcdtotal: '',
      rules: {
        adcdid: [
          { required: true, message: '请选择乡镇', trigger: 'change' }
        ],
        population: [
          { validator: this.Global.checkNumeral }
        ],
        landArea: [
          { validator: this.Global.checkNumeral }
        ],
        cultiArea: [
          { validator: this.Global.checkNumeral }
        ],
        property1: [
          { validator: this.Global.checkNumeral }
        ],
        property2: [
          { validator: this.Global.checkNumeral }
        ],
        property3: [
          { validator: this.Global.checkNumeral }
        ],
        property4: [
          { validator: this.Global.checkNumeral }
        ],
        housecondition1: [
          { validator: this.Global.checkNumeral }
        ],
        housecondition2: [
          { validator: this.Global.checkNumeral }
        ],
        housecondition3: [
          { validator: this.Global.checkNumeral }
        ],
        housecondition4: [
          { validator: this.Global.checkNumeral }
        ]
      }
    }
  },
  methods: {
    // 乡镇选择
    townAdcd: function (townAdcd) {
      this.loading = true
      this.aDCD = townAdcd
      this.thedata()
    },
    // 表头换行
    renderheader (h, { column, $index }) {
      return h('span', {}, [
        h('span', {}, column.label.split('/')[0]),
        h('br'),
        h('span', {}, column.label.split('/')[1])
      ])
    },
    // 获取表格数据
    thedata () {
      this.loading = true
      this.$store.dispatch(scenceTypes.GET_PREVENTION_AREAINFO, { aDCD: this.aDCD, pageIndex: this.pageIndex, pageSize: this.pageSize }).then(data => {
        this.tdata = data.results
        this.loading = false
      })
    },
    // 获取乡镇数据
    adcddata () {
      this.$store.dispatch(monitorTypes.GET_ADCD, {
        isTown: this.isTown,
        searchName: this.searchName,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }).then(data => {
        this.adcdtotal = data.total
        this.towns = data.results
      })
    },
    // 切割乡镇code
    adcdchange (adcd) {
      this.aDCD = adcd.substring(0, 9)
      this.thedata()
    },
    //  行选中
    clickRow (row) {
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    handleSelectionChange (val) {
      this.multipleSelection = JSON.parse(JSON.stringify(val))
    },
    // 新增
    addDialog () {
      this.status = '新增'
      this.form = {}
      this.addbtn = true
      this.Global.clearValidate(this, 'groupForm')
    },
    // 编辑
    editDialog () {
      this.status = '编辑'
      if (this.multipleSelection.length < 1) {
        this.$alert('需要选择一条数据才可进行该操作！请选择其中一条数据。', '提示')
      } else if (this.multipleSelection.length > 1) {
        this.$alert('该操作不可对多条数据同时进行操作。', '提示')
      } else {
        this.form = {}
        this.addbtn = true
        this.form = Object.assign({}, this.multipleSelection[0])
        this.Global.clearValidate(this, 'groupForm')
      }
    },
    // 删除
    delDialog (rows) {
      if (rows < 1) {
        this.$alert('请先勾选需要删除的数据项！', '提示')
      } else {
        this.delId = [] // 清空数组
        rows.forEach(item => {
          this.delId.push(item.id)
        })
        this.$confirm(`确定要删除已选择的防治区数据 ?`, '确认').then(() => {
          this.loading = true
          this.$store.dispatch(scenceTypes.DELETE_PREVENTION_AREAINFO, { id: this.delId.join(',') }).then(() => {
            this.loading = false
            this.$notify.success({ title: '成功', message: '删除数据成功.' })
            this.thedata()
          }).catch(() => { this.loading = false })
        }).catch(() => {})
      }
    },
    handleChange (val) {
      var valueIndex = val.length
      this.valueId = val[valueIndex - 1]
    },
    // 获取三级联动数据
    getMutiRanksAdcd () {
      this.$store.dispatch(scenceTypes.GET_MUTIRANKS_ADCD, {
        parentAdcdCode: this.aDCD
      }).then(data => {
        this.mutiRanksAdcd = data.results
      })
    },
    searchtown () {
      this.thedata()
    },
    // 保存新建/编辑
    onGroupSave () {
      this.$refs['groupForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          this.form.aDCDID = this.valueId
          this.$store.dispatch(scenceTypes.SAVE_PREVENTION_AREAINFO, this.form).then((response) => {
            this.loading = false
            this.addbtn = false
            if (response.result === 'Success') {
              this.$notify.success({ title: '成功', message: '保存成功。' })
            } else {
              this.$notify.error({ title: '失败', message: response.msg })
              return false
            }
            this.thedata()
            this.form = {}
          }).catch(() => { this.loading = false })
        }
      })
    }
  },
  computed: {
    allowsPerm: {
      get () {
        return this.$store.state.allowPerm
      },
      set () {
        this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
      }
    }
  },
  created () {
    this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
  },
  mounted () {
    this.thedata()
    this.adcddata()
    this.getMutiRanksAdcd()
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('content')
      let countryListDiv = document.getElementsByClassName('countryList')
      this.$refs['skt'].style.height = (contentDiv[0].offsetHeight - countryListDiv[0].offsetHeight - 45) + 'px'
      let selectDiv = document.getElementsByClassName('select')
      this.height = this.$refs['skt'].offsetHeight - 20 - selectDiv[0].offsetHeight
    })
  }
}
</script>
<style lang="less" src="@/assets/scene.less" scoped>
</style>
<style scoped>
.scence >>> .el-dialog {
  margin: 0 auto !important;
}
.scence >>> .el-table__body,.scence >>> .el-table__header{
  width: auto!important;
}
.scence >>> .del_dialog .el-dialog__body .del_tip{
  display: block;
  width: 80%;
  font-size: 18px;
  margin: 10% auto;
  text-align: center;
}
</style>
